import { useContext } from 'react';
import { DialogConfigContext } from './DialogConfigContext';


export default function useDialogConfig() {
  return useContext(DialogConfigContext);
};
